export default __webpack_public_path__ + "65c3c4e355876a3e0a9eb882613ea392.png";